export const newId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`);

export const isBlank = (v) => v === undefined || v === null || v === "";

export function fmtDay(iso, opts = { weekday: "long", day: "numeric", month: "long" }) {
  return new Date(`${iso}T00:00:00`).toLocaleDateString("en-AU", opts);
}

export const plural = (n, word) => `${n} ${n === 1 ? word : word.endsWith("y") ? `${word.slice(0, -1)}ies` : `${word}s`}`;

export function optionLabel(field, v) {
  if (isBlank(v)) return null;
  return (field.options || []).find((o) => o.value === v)?.label || String(v);
}

export function fieldDisplay(field, v) {
  if (isBlank(v)) return "—";
  if (field.type === "single") return optionLabel(field, v);
  if (field.type === "rating") return `${v}/10`;
  return field.unit ? `${v} ${field.unit}` : String(v);
}

export function getDay(diary, n) {
  return diary.days?.[String(n)] || { entries: [], notes: {} };
}

export function setDay(diary, n, day) {
  const days = { ...(diary.days || {}) };
  if (!day.entries.length && !Object.values(day.notes || {}).some((v) => !isBlank(v))) delete days[String(n)];
  else days[String(n)] = day;
  return { ...diary, days };
}

/** Entries from earlier days whose next-day questions are still blank. */
export function pendingFollowups(diary, calendar, followupFields) {
  const out = [];
  calendar.filter((d) => d.followup_open).forEach((d) => {
    getDay(diary, d.n).entries.forEach((e) => {
      if (followupFields.some((f) => isBlank(e[f.code]))) out.push({ day: d, entry: e });
    });
  });
  return out;
}
